import React, { Component } from "react";
import getWeb3 from "./getWeb3";

import "./App.css";

class App extends Component {
  state = { web3: null, accounts: null, value: [0, 0, 0, 0, 0] };

  componentDidMount = async () => {


    try {
      // Get network provider and web3 instance.
      const web3 = await getWeb3();
      const value = 0;

      // Use web3 to get the user's accounts.
      const accounts = await web3.eth.getAccounts();

      // Get the contract instance.
      const networkId = 97;
      this.setState({ web3, accounts, value }, this.runCode);

    } catch (error) {
      // Catch any errors for any of the above operations.
      alert(
        `Failed to load web3, accounts, or contract. Check console for details.`,
      );
      console.error(error);
    }
  };

  runCode = async () => {
    const { web3, accounts } = this.state;
    const { Client } = require('@bandprotocol/bandchain.js');
    const endpoint = 'https://api-gm-lb.bandchain.org';
    const client = new Client(endpoint);

    async function arbGetReferenceData(token1, token2, token3) {
      const rate = await client.getReferenceData([token1, token2, token3]);
      const arbVal = parseFloat((rate[0].rate).toFixed(8)) * parseFloat((rate[1].rate).toFixed(8)) * parseFloat((rate[2].rate).toFixed(8));
      return arbVal;
    }
    const etharbvalue = await arbGetReferenceData("BTC/ETH", "ETH/DAI", "DAI/BTC");
    console.log(etharbvalue);
    const swparbvalue = await arbGetReferenceData("BTC/SXP", "SXP/DAI", "DAI/BTC");
    console.log(swparbvalue);
    const swpetharbvalue = await arbGetReferenceData("BTC/SXP", "SXP/ETH", "ETH/BTC");
    console.log(swpetharbvalue);
    const bnbetharbvalue = await arbGetReferenceData("BTC/BNB", "BNB/BUSD", "BUSD/BTC");
    console.log(bnbetharbvalue);
    const busdetharbvalue = await arbGetReferenceData("BTC/BNB", "BNB/ETH", "ETH/BTC");
    console.log(busdetharbvalue);
    const value = [etharbvalue, swparbvalue, swpetharbvalue, bnbetharbvalue, busdetharbvalue];
    this.setState({ web3, accounts, value });
  };

  render() {
    if (!this.state.web3) {
      return <div>Loading Web3, accounts, and contract...</div>;
    }
    return (
      <div className="App-header">
        <div> Hit refresh to see the current value before performing flash loan</div>
        <div> Press the button when profit is greater than 0</div>
        <br></br>
        <br></br>
        <button onClick={event => alert(event.target.id)}>
          <span role="img" aria-label="Flash loan" id="Flash loan in progress">⚡️</span>
        </button>
        <br></br>
        <div>The BTC/ETH/DAI arbitrage Value  is: {this.state.value[0]}</div>
        <br></br>
        <div> Indicative profit for 1000x leverage in BTC-B: {(this.state.value[0] - 1.0001) * 300000} USD </div>
        <br></br>
        <br></br>
        <div>The BTC/SWP/DAI arbitrage Value  is: {this.state.value[1]}</div>
        <br></br>
        <div> Indicative profit for 1000x leverage in BTC-B: {(this.state.value[1] - 1.0001) * 300000} USD </div>
        <br></br>
        <br></br>
        <div>The BTC/SWP/ETH arbitrage Value  is: {this.state.value[2]}</div>
        <br></br>
        <div> Indicative profit for 1000x leverage in BTC-B : {(this.state.value[2] - 1.0001) * 300000} USD </div>
        <br></br>
        <br></br>
        <div>The BTC/BNB/BUSD arbitrage Value  is: {this.state.value[2]}</div>
        <br></br>
        <div> Indicative profit for 1000x leverage in BTC-B : {(this.state.value[3] - 1.0001) * 300000} USD </div>
        <br></br>
        <br></br>
        <div>The BTC/BNB/ETH arbitrage Value  is: {this.state.value[2]}</div>
        <br></br>
        <div> Indicative profit for 1000x leverage in BTC-B : {(this.state.value[4] - 1.0001) * 300000} USD </div>
        <br></br>
        <br></br>
      </div>

    );
  }
}

export default App;
